import styled from "styled-components";

export const Container = styled.div`
  padding: 64px;
  min-height: 100%;
  background-color: var(--ghost);

  @media only screen and (max-device-width: 812px) {
    padding: 0 0 64px;
    background-color: var(--white);
  }
`;

export const Content = styled.div`
  padding: 48px;
  margin: 0 auto;
  max-width: 750px;
  border-radius: 8px;
  background-color: var(--white);
  box-shadow: 0px 4px 8px 0px #e0e0e0;

  &.transparent {
    padding: 8px 0;
    box-shadow: none;
    background-color: transparent;
  }

  .ant-form-item-label {
    label.ant-form-item-required {
      height: 32px;
      font-weight: 600;
      :before {
        display: none;
      }
    }
  }

  .ant-btn {
    font-weight: 500;
    text-transform: uppercase;
  }

  .ant-btn-link {
    padding: 0;
    text-transform: none;
    &.signout {
      color: var(--ant-error-color);
    }
  }

  .ant-upload {
    font-weight: normal;
    .upload-logo {
      width: 100%;
      display: flex;
      padding: 8px 16px;
      flex-direction: row;
      justify-content: space-between;

      .upload-drag-icon {
        width: 140px;
        height: 100%;
        margin: 8px;

        .anticon-download {
          font-size: 60px;
        }

        img {
          max-height: 70px;
        }
      }

      .upload-text {
        display: flex;
        max-width: 380px;
        flex-direction: column;
        .ant-upload-hint {
          font-size: 11px;
        }
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    box-shadow: none;
    border-radius: 0;
    padding: 0 24px 48px;
    border-bottom: 1px solid var(--ghost);

    &.transparent {
      border-bottom: none;
      padding: 0 24px;
    }
  }
`;
